<div class="people-likes">
  @if (myFavourite$ | async; as data) {
    @if (showFavouriteButton) {
      <ng-container
        [ngTemplateOutlet]="button"
        [ngTemplateOutletContext]="{
          active: data?.myFavourite,
          registryName: 'bello',
          registryNameActive: 'bello',
          label: 'people-likes.add-favourite',
          labelActive: 'people-likes.remove-favourite',
          type: 'favourite',
        }"></ng-container>
    }
    @if (showLikeButton) {
      <ng-container
        [ngTemplateOutlet]="button"
        [ngTemplateOutletContext]="{
          active: data?.bookmarked,
          registryName: 'bookmark-simple',
          registryNameActive: 'bookmark-fill',
          label: 'people-likes.add-like',
          labelActive: 'people-likes.add-like',
          type: 'like',
        }"></ng-container>
    }
    @if (showShareButton) {
      <ng-container
        [ngTemplateOutlet]="button"
        [ngTemplateOutletContext]="{
          active: false,
          registryName: 'share-network',
          registryNameActive: 'share-network',
          label: 'people-likes.share',
          labelActive: 'people-likes.share',
          type: 'share',
        }"></ng-container>
    }
  }
</div>

<ng-template
  #button
  let-active="active"
  let-label="label"
  let-labelActive="labelActive"
  let-registryName="registryName"
  let-registryNameActive="registryNameActive"
  let-type="type">
  <button
    class="is-mobile-not-ipad sharry-small"
    mat-icon-button
    [color]="active ? 'primary' : 'secondary'"
    (click)="onClick(type)">
    <sharry-icon
      svgClass="svg-icon"
      [registryName]="active ? registryNameActive : registryName"></sharry-icon>
  </button>
  <button
    class="people-likes__ipad-desktop sharry-medium no-border"
    mat-stroked-button
    [class.people-likes__button--active]="active"
    [color]="active ? 'primary' : 'secondary'"
    (click)="onClick(type)">
    <sharry-icon
      svgClass="svg-icon"
      [registryName]="active ? registryNameActive : registryName"></sharry-icon>
    <span>{{ (active ? labelActive : label) | i18next }}</span>
  </button>
</ng-template>
